import React, { useRef } from 'react'
import Dropzone, { DropzoneRef } from 'react-dropzone'

import classnames from 'classnames'
import { Button, Icon } from 'component-library-next'

import document from './document.svg'

import './style.scss'

export type UploadDropzoneProps = {
  onUpload: (files: File[]) => void
}

export const UploadDropzone = ({ onUpload }: UploadDropzoneProps) => {
  const dropzoneRef = useRef<DropzoneRef>(null)
  return (
    <Dropzone
      noClick={true}
      accept={{
        'application/pdf': ['.pdf'],
        'application/msword': ['.doc'],
        'application/vnd.openxmlformats': ['.docx'],
        'image/jpeg': ['.jpg', '.jpeg'],
        'image/png': ['.png']
      }}
      ref={dropzoneRef}
      onDrop={(acceptedFiles) => onUpload(acceptedFiles)}
    >
      {({ isDragActive, getRootProps, getInputProps }) => {
        return (
          <div {...getRootProps()}>
            <div
              className={classnames([
                'upload-file-dropzone',
                `file-uploader ${isDragActive ? 'active-dropzone' : ''}`
              ])}
              onClick={() => {
                dropzoneRef.current?.open()
              }}
            >
              <div className={'upload-file-dropzone__grid'}>
                <div className={'upload-file-dropzone__icons'}>
                  <Button shape={Button.shapes.Circle}>
                    <Icon alt='add' name={Icon.names.plus} />
                  </Button>
                </div>
                <div id={'upload-file-dropzone__box-text'}>
                  <p>
                    <b>Weitere Dokumente</b>
                  </p>
                  <p>
                    Laden Sie hier Dokumente wie Vorlagen oder Schriftverkehr von der Gegenseite
                    hoch.
                  </p>
                  <p>Unterstützte Formate: PDF, DOC, DOCX, JPG, JPEG, PNG</p>
                </div>
                <div className={'upload-file-dropzone__icons'}>
                  <img src={document} alt='document' />
                </div>
                <input {...getInputProps()} />
              </div>
            </div>
          </div>
        )
      }}
    </Dropzone>
  )
}
